import { get } from 'lodash';

import { useQuerySubnetworks } from 'hb-react/shared/hooks/useQuerySubnetworks';

export const getSubnetworkOptions = () =>
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useQuerySubnetworks({
    defaultData: () =>
      get(AlumniConnect, ['currentNetwork', 'subnetworks'], []),
    fallbackData: () => null,
  });

export const getDefaultSubnetworkPlaceholder = () =>
  get(AlumniConnect, [
    'currentNetwork',
    'user_fields_config',
    'sub_networks_placeholder',
  ]) || I18n.t('web.users.search.sub_networks');
